import { toast } from "react-toastify";
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_FINANCE_API_URL } from "../../../../Constants/baseConstant";
import { getDomain, getUserId } from "../../../Base/helper/baseFunctions";


export const GetPaySummaryTileViewHelper = async (params) => {
  return await axiosInstance(`/finance/payroll/getPaySummaryTileView`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      year: params?.year 
    }
  })
    .then((res) => ({
      message: "Pay summary tile retrieved successfully",
      hasError: false,
      data: res?.data,
    }))
    .catch((err) => ({
      message: "Unable to retrieve pay summary tile",
      hasError: true,
      data: err?.response?.data,
    }));
};

export const UpdatePayrollApproverStatusHelper = async (params) => {
  toast.dismiss();
  toast.info("Saving...");
  return await axiosInstance(`/finance/payroll/updatePayrollApproverStatus`, {
    method: "PUT",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getUserId(),
      status: params?.status,
      payroll_type: params?.payroll_type,
      month: params?.month,  
      year: params?.year
      
    }
  })
  .then((res) => {
    toast.dismiss();
    toast.success(`Status updated successfully`);
      return {
        message: "Status updated successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return {
        message: "Unable to update status",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

export const GetPayrollUngriggeredMonthsHelper = async (params) => {
  return await axiosInstance(`/finance/payroll/getPayrollMonthsUntriggered`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      current_year: params?.current_year 
    }
  })
    .then((res) => ({
      message: "Payroll untriggered month retrieved successfully",
      hasError: false,
      data: res?.data,
    }))
    .catch((err) => ({
      message: "Unable to retrieve payroll untriggered month",
      hasError: true,
      data: err?.response?.data,
    }));
};
